import React from 'react';
import { Box, Typography, Container, FormControlLabel, Switch } from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';
import WbButton from '../../../components/common/WbButton';
import WbLoader from '../../../components/common/WbLoader';
import KioskLayout from '../../../components/kiosk/KioskLayout';
import { useKiosk } from '../../../contexts/KioskContext';
import paths from '../../../routes/paths';
import '../KioskStyles.scss';
import {iconStartSurvey } from '../../../components/assets/images';

export default function StudentWelcome() {
  const { schoolSlug } = useParams();
  const { school, loading, widgitEnabled, toggleWidgit } = useKiosk();
  const navigate = useNavigate();

  if (loading) {
    return (
      <KioskLayout>
        <WbLoader />
      </KioskLayout>
    );
  }

  const schoolName = school?.schoolName || 'School';

  return (
    <KioskLayout>
      <Container maxWidth="md">
        <Box className="kiosk-card" sx={{ textAlign: 'center' }}>
          <div className="kiosk-title">
            {schoolName}'s Survey Portal
          </div>
          <div className="kiosk-subtitle">
            Click here to start the survey
          </div>

          <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2, }}>
            <WbButton
              CustomButtonText="Start Survey"
              onClick={() => navigate(paths.kioskStudentSearch.replace(':schoolSlug', schoolSlug))}
              className="kiosk-button-secondary"
              startIcon={<img src={iconStartSurvey} alt="Start Survey" />}              
            />
          </Box>

          <Box className="kiosk-widgit-toggle">
            <FormControlLabel
              control={
                <Switch
                  checked={widgitEnabled}
                  size='small'
                  onChange={(e) => toggleWidgit(e.target.checked)}                  
                  sx={{
                    '& .MuiSwitch-switchBase.Mui-checked': {
                      color: 'var(--kiosk-secondary-color, #E84F6B)',
                    },
                    '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
                      backgroundColor: 'var(--kiosk-secondary-color, #E84F6B)',
                    },
                  }}
                />
              }
              label="Enable Widgit Support"
            />
          </Box>

        </Box>
      </Container>
    </KioskLayout>
  );
}
